// Modules
import React from 'react'
import OwlCarousel from 'react-owl-carousel'
import { Link } from 'gatsby'

// Styles
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

function Carousel ({ plans, link }) {
  return (
    <OwlCarousel
      autoWidth
      items={3}
      margin={12}
      dots={false}
      startPosition={1}>
      {plans.length > 0 && plans.map((plan, index) =>
        <Link
          to={!!plan?.link ? plan.link : link}
          key={plan}
          className="transition-all md:w-82 md:h-80 w-73 h-60 flex flex-shrink-0 bg-black text-white flex-col rounded-md p-8 pb-7">
          <p className="text-body_xl md:text-heading_2xl font-black">{plan.title}</p>
          {!!plan.description && <p className="mt-5 text-body_base line-clamp-3 md:line-clamp-4">{plan.description}</p>}
          {!!plan.price && <h3 className="self-end text-body_lg md:text-heading_lg font-black mt-auto">{`GHS ${plan.price}`}</h3>}
        </Link>
      )}
    </OwlCarousel>
  )
}

export default Carousel